import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useField } from 'formik'
import ProductCategoryService from 'domains/product-category/services/product-category-service'
import ReactSelectSearchField from 'components/molecules/react-select-search-field'
import { CATEGORY_OPTIONS, DATA_TYPE } from 'domains/fast-sell-product/constants'

const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool,
  dataType : PropTypes.string
}

const defaultProps = {
  name     : 'category',
  label    : 'Kategori',
  required : false,
  dataType : DATA_TYPE.CONST
}
/**
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {string} dataType - Choice between endpoint or const to get the data
 * @param {object} props - another props to be sent to select-search-field
 */
const FastSellProductCategorySelectField = ({
  name,
  label,
  required,
  dataType,
  ...props
}) => {
  const [ isLoading, setIsLoading ]   = useState(true)
  const [ categories, setCategories ] = useState([])
  const [ field ]                     = useField(name)
  const { value }                     = field

  const fetchCategories = useCallback(async () => {
    let response = {}

    // will be used if we implement API call
    // if (dataType === DATA_TYPE.ENDPOINT) {
    // response = await FastSellCategoriesApi.index()
    // }

    if (dataType === DATA_TYPE.CONST) {
      response = {
        data: {
          categories: [
            ...CATEGORY_OPTIONS
          ]
        }
      }
    }

    setIsLoading(false)
    return response.data.categories
  },[ dataType ])

  useEffect(() => {
    /** expecting it always render once at the first time */
    const getInitialOption = async () => {
      const options      = await fetchCategories()
      const groupOptions = ProductCategoryService.formatToReactSelectOptions(options)
      setCategories(groupOptions)

      // there' some case that value is still undefined
      // for now, we can solve by skip it before it go through to the logic below
      if (!value) return

      let selectedOption = options.find((option) => option.id === Number(value))

      if (!selectedOption) return
    }

    getInitialOption()
  }, [ value, fetchCategories ])

  const formatGroupLabel = (data) => (
    <div>
      <span><strong>{ data.label }</strong></span>
    </div>
  )

  /**
   * Get all options from grouped format react-select
   * @param {array} groupOptions - grouped format. see `ProductCategoryService.formatToReactSelectOptions`
   */
  const getOptionsFromGroupedFormat = (groupOptions) => {
    let formattedOptions = []
    groupOptions.forEach((groupOption) => {
      formattedOptions =[
        ...formattedOptions,
        ...groupOption.options
      ]
    })

    return formattedOptions
  }


  return (
    <ReactSelectSearchField
      name={ name }
      label={ label }
      required={ required }
      dataList={ categories }
      isLoading={ isLoading }
      isClearable={ true }
      formatGroupLabel={ formatGroupLabel }
      getOptions={ getOptionsFromGroupedFormat }
      { ...props }
    />
  )
}

FastSellProductCategorySelectField.propTypes    = propTypes
FastSellProductCategorySelectField.defaultProps = defaultProps

export default FastSellProductCategorySelectField